/* ------------------------------------------------------------------
   SET BUILDER
   Runs on set pages only (the snippet prints the map, no map no script).

   The page product is a native Shopify bundle used as a shell. Adding the
   bundle itself to the bag breaks engraving and changes what the warehouse
   receives, so every add-to-bag request from this page is rewritten just
   before it leaves: the chosen set option becomes the real bracelet variant
   and the add-ons follow as their own lines.

   Both add paths on this theme end in fetch('/cart/add.js'): the native
   product form posts FormData, the engraving tool posts JSON. Rewriting at
   fetch covers both without touching either, and the theme already accepts
   the multi-item response shape.
------------------------------------------------------------------ */
(function () {
  var el = document.querySelector('[data-set-map]');
  if (!el) return;
  var map;
  try { map = JSON.parse(el.textContent); } catch (e) { return; }
  if (!map || !map.variants) return;

  var nativeFetch = window.fetch;

  function isCartAdd(url, opts) {
    if (!opts || String(opts.method || '').toUpperCase() !== 'POST') return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
  }

  /* Swap set options for real products. Returns null when nothing in the
     request is a set, so unrelated adds (cart upsells) pass through as is. */
  function expand(items) {
    var touched = false, out = [];
    items.forEach(function (item) {
      var hit = map.variants[String(item.id)];
      if (!hit || !hit.bracelet) { out.push(item); return; }
      touched = true;
      var qty = parseInt(item.quantity, 10) || 1;
      var bracelet = { id: hit.bracelet, quantity: qty };
      if (item.properties) bracelet.properties = item.properties;
      out.push(bracelet);
      (map.addons || []).forEach(function (a) {
        if (a.id) out.push({ id: a.id, quantity: qty, properties: { _set: map.handle || '' } });
      });
    });
    return touched ? out : null;
  }

  function fromFormData(fd) {
    var item = { id: fd.get('id'), quantity: fd.get('quantity') || 1 };
    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    return {
      items: [item],
      sections: fd.get('sections') || '',
      sections_url: fd.get('sections_url') || ''
    };
  }

  /* Apply this set's code once its pieces are in the bag. Codes already on
     the cart (FAM10, say) are kept alongside it: none of them combine, so
     Shopify simply applies whichever saves more. */
  function applySetCode(sections, sectionsUrl) {
    if (!map.code) return Promise.resolve(null);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return nativeFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        if (codes.indexOf(map.code) === -1) codes.push(map.code);
        var body = { discount: codes.join(',') };
        /* Re-render the drawer sections as part of this update, so they
           include the saving. */
        if (sections) { body.sections = sections; body.sections_url = sectionsUrl || ''; }
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .catch(function () { return null; /* the pieces are still in the bag at full price */ });
  }

  window.fetch = function (url, opts) {
    var isSetAdd = false, payload = null;
    try {
      if (isCartAdd(url, opts)) {
        if (opts.body instanceof FormData) payload = fromFormData(opts.body);
        else if (typeof opts.body === 'string') payload = JSON.parse(opts.body);

        if (payload && Array.isArray(payload.items)) {
          var items = expand(payload.items);
          if (items) {
            isSetAdd = true;
            payload.items = items;
            var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
            opts = Object.assign({}, opts, { body: JSON.stringify(payload), headers: headers });
          }
        }
      }
    } catch (e) { /* never block an add: fall through with the original request */ }
    var req = nativeFetch.call(this, url, opts);
    if (!isSetAdd) return req;
    /* The drawer HTML in the add response is rendered before the code is on,
       so it showed full price until checkout. Apply the code, then swap in the
       sections re-rendered by that update so the drawer shows the set price. */
    return req.then(function (res) {
      if (!res.ok) return res;
      return res.clone().json().then(function (addJson) {
        return applySetCode(payload && payload.sections, payload && payload.sections_url).then(function (up) {
          if (!up || !up.sections) return res;
          addJson.sections = Object.assign({}, addJson.sections || {}, up.sections);
          return new Response(JSON.stringify(addJson), {
            status: res.status,
            headers: { 'Content-Type': 'application/json' }
          });
        });
      }).catch(function () { return res; });
    });
  };

  /* The engraving preview is drawn per product, and this page's product is the
     set, so it would always show gold. Follow the chosen finish instead. A
     variant change can leave stale copies of the modal behind, so update all. */
  function paintPreview(variantId) {
    var hit = map.variants[String(variantId)];
    var src = hit && map.previews && map.previews[hit.finish];
    if (!src) return;
    [].forEach.call(document.querySelectorAll('.ce-modal__img'), function (img) { img.src = src; });
  }
  document.addEventListener('variant:change', function (ev) {
    var v = ev.detail && ev.detail.variant;
    if (v && v.id) paintPreview(v.id);
  });
  var first = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (first && first.value) paintPreview(first.value);
})();
